import { render, staticRenderFns } from "./Runner.vue?vue&type=template&id=bfb06754&scoped=true&"
import script from "./Runner.vue?vue&type=script&lang=ts&"
export * from "./Runner.vue?vue&type=script&lang=ts&"
import style0 from "./Runner.vue?vue&type=style&index=0&id=bfb06754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb06754",
  null
  
)

export default component.exports